import {
  ConfirmSwapButtons,
  ConfirmSwapContainer,
  ConfirmSwapHeader,
} from "./styled";
import default_token_image from "../../../../assets/Dashboard/Common/default-token-image.png";
import { ButtonCommon } from "../../../../Layout/styled";
import Loading from "../../../../components/Loading";
import SwapDetails from "../Tabs/Details";
import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { ContextProviderWrapper } from "../../../../components/Context";
import { AVAX_API } from "../../../../services/api/indexV2";
import { useSendTransaction } from "wagmi";
import getTokenInfo from "../../../../utils/checkInfoByAccount";
import web3 from "web3";
import { ethers } from "ethers";
import { abiToken } from "../../../../components/contract/ABI";
import { useAppKitAccount, useAppKitProvider } from "@reown/appkit/react";
import { useDispatch } from "../../../../store/store";
import {
  getDataTokenLogin,
  getDataListHistory,
} from "../../../../store/features/poolsSlice";
import { useSelector } from "react-redux";
import { BlockRightRow, BlockSteps } from "../../Launchpad/Detail/styled";
import { instanceV2 } from "../../../../services/instanceV2";
import { Connection, VersionedTransaction } from "@solana/web3.js";
import Solflare from "@solflare-wallet/sdk";
import { Provider } from "@reown/appkit-adapter-solana/react";
import { useTonAddress, useTonConnectUI } from "@tonconnect/ui-react";

const STEPS = [
  {
    title: "Creating transaction",
    description: "Your transaction is creating",
  },
  {
    title: "Sending transaction",
    description: "Your transaction is sending",
  },
  {
    title: "Verify transaction",
    description: "Your transaction is verify",
  },
];

declare const window: Window & typeof globalThis & { ethereum: any };
const ConfirmSwap = ({
  fromAsset,
  toAsset,
  fromAmount,
  toAmount,
  minReceived,
  slippageTolerance,
  openConfirmModal,
  setOpenConfirmModal,
  simulateState,
  realPrice,
  setFromAmount,
  setToAmount,
  setTextModalTransaction,
  onRefresh,
  keyRoute,
  chainRouter,
}: any) => {
  const SOLANA_RPC =
    "https://cosmological-few-putty.solana-mainnet.quiknode.pro/3b7a708d5d20d54c81084dfed016862055472c2e/";
  const { theme } = useContext(ContextProviderWrapper)!;
  const { walletProvider } = useAppKitProvider<Provider>("solana");
  const { address }: any = useAppKitAccount();
  const [isLoading, setIsLoading] = useState(false);
  const [isCreating, setIsCreating] = useState(true);
  const [allowance, setAllowance] = useState<any>(0);
  const [stepActive, setStepActive] = useState(0);
  const [isVerified, setIsVerified] = useState(true);
  const [isSentTx, setIsSentTx] = useState(true);
  const [isSwap, setIsSwap] = useState(false);
  const { isSuccess, isError, sendTransaction, data } = useSendTransaction();
  const Web3 = new web3(window.ethereum);
  const [txId, setTxId] = useState(null);
  const [reCallFunc, setReCallFunc] = useState(false);
  const dispatch = useDispatch();
  const { listTokens, listChains }: any = useSelector(
    (state: any) => state.pool
  );
  const addressTon = useTonAddress();
  const [tonConnectUI] = useTonConnectUI();

  useEffect(() => {
    if (isError) {
      toast.error("Send Transaction Failed");
      setIsSentTx(false);
      setStepActive(2);
    }
    if (isSuccess) {
      setStepActive(2);

      handleVerifyTx({
        transaction_id: txId,
        hash: data,
        chain_id: listChains?.find((item: any) => item.name === chainRouter)
          ?.chainId,
      });
    }
  }, [isError, isSuccess]);

  const handleGetHistory = async (listTokens: any[]) => {
    try {
      if (!address) return;
      const { data } = await AVAX_API.getTx();
      const newList = data.data?.map((item: any) => {
        return {
          ...item,
          src_address: listTokens.find(
            (token: any) => token.address === item?.src_address
          )?.src_address,
          src_symbol: listTokens.find(
            (token: any) => token.address === item?.src_address
          )?.symbol,
          src_img: listTokens.find(
            (token: any) => token.address === item?.src_address
          )?.img,
          dest_address: listTokens.find(
            (token: any) => token.address === item?.dest_address
          )?.dest_address,
          dest_symbol: listTokens.find(
            (token: any) => token.address === item?.dest_address
          )?.symbol,
          dest_img: listTokens.find(
            (token: any) => token.address === item?.dest_address
          )?.img,
        };
      });
      dispatch(getDataListHistory(newList));
    } catch (error) {
      console.log("errrr", error);
    }
  };

  const handleVerifyTx = async (params: any) => {
    try {
      try {
        await AVAX_API.verifyTx(params);
        setStepActive(3);
        setOpenConfirmModal(false);
        setIsLoading(false);
        setIsSwap(false);
        onRefresh();
        toast.success("Swap Successfully");
        setTimeout(() => {
          handleGetHistory(listTokens);
        }, 3000);
      } catch (error) {
        setStepActive(3);
        setIsVerified(false);
        toast.error("Verify Transaction Failed");
      }
    } catch (error: any) {
      console.log("handleVerifyTx err", error);
    }
  };

  const handleExcuteSwap = async () => {
    try {
      if (isLoading) return;
      const token = localStorage.getItem("TOKEN");
      if (!token) {
        dispatch(getDataTokenLogin("SIGN"));
        setReCallFunc(true);
        return;
      }
      setIsLoading(true);

      setIsSwap(true);
      const gasPrice = await Web3.eth.getGasPrice();
      let pathApiSwap = "";
      let params = null;
      switch (keyRoute) {
        case "1inch":
          pathApiSwap = "/api/swap/1inch";
          params = {
            fromTokenAddress: fromAsset?.address,
            toTokenAddress: toAsset?.address,
            amount: simulateState?.offerUnits,
            chainId: listChains?.find((item: any) => item.name === chainRouter)
              ?.chainId,
            slippage: simulateState?.slippage,
            gasPrice,
          };
          break;
        case "velora":
          pathApiSwap = "/api/swap/create";
          params = {
            srcToken: fromAsset?.address,
            destToken: toAsset?.address,
            amount: simulateState?.offerUnits,
            network: listChains?.find((item: any) => item.name === chainRouter)
              ?.chainId,
          };
          break;
        case "kyberswap":
          pathApiSwap = "/api/swap/kyber";
          params = {
            srcToken: fromAsset?.address,
            destToken: toAsset?.address,
            amount: simulateState?.offerUnits,
            chainId: listChains?.find((item: any) => item.name === chainRouter)
              ?.chainId,
            slippage: simulateState?.slippage,
          };
          break;
        case "odos":
          pathApiSwap = "/api/swap/odos";
          params = {
            pathId: simulateState?.pathId,
          };
          break;
        case "rubic":
          pathApiSwap = "/api/swap/rubic";
          params = {
            srcToken: fromAsset?.address,
            destToken: toAsset?.address,
            amount: simulateState?.offerUnits,
            network: listChains?.find((item: any) => item.name === chainRouter)
              ?.chainId,
          };
          break;

        default:
          pathApiSwap = "/api/swap/rubic";
          params = {
            srcToken: fromAsset?.address,
            destToken: toAsset?.address,
            amount: simulateState?.offerUnits,
            chainId: listChains?.find((item: any) => item.name === chainRouter)
              ?.chainId,
            slippage: simulateState?.slippage,
          };
          break;
      }

      const { data } = await instanceV2.get(`${pathApiSwap}`, { params });

      let dataToSwap: any = null;
      switch (keyRoute) {
        case "1inch":
          break;
        case "velora":
          dataToSwap = {
            account: address,
            to: data?.swap_data?.to,
            chainId: Number(process.env.REACT_APP_CHAIN_ID),
            value: data?.swap_data?.value,
            gasPrice: data?.swap_data?.gasPrice,
            gas: data?.swap_data?.gas,
            data: data?.swap_data?.data,
          };
          break;
        case "kyberswap":
          dataToSwap = {
            account: address,
            to: data?.swap_data?.routerAddress,
            chainId: Number(process.env.REACT_APP_CHAIN_ID),
            value: data?.swap_data?.transactionValue,
            gasPrice,
            gas: data?.swap_data?.gas,
            data: data?.swap_data?.data,
          };
          break;
        case "odos":
          break;
        case "rubic":
          dataToSwap = {
            account: address,
            to: data?.swap_data?.to,
            chainId: Number(process.env.REACT_APP_CHAIN_ID),
            value: data?.swap_data?.value,
            gasPrice,
            gas: data?.swap_data?.gas,
            data: data?.swap_data?.data,
          };
          break;

        default:
          break;
      }
      setStepActive(1);
      setTxId(data?.transaction_id);
      if (chainRouter === "Solana") {
        handleSwapSolana(data.swap_data?.data, data?.transaction_id);
      } else if (chainRouter === "Toncoin") {
        handleSwapTon(data?.swap_data, data?.transaction_id);
      } else {
        console.log("dataToSwap",dataToSwap)
        sendTransaction(dataToSwap);
      }
    } catch (error: any) {
      console.log("ERR", error);
      setStepActive(1);
      setIsLoading(false);
      setIsCreating(false);
      toast.error(
        error && error.message
          ? error.message.substring(0, 55) + "..."
          : "Create Transaction Failed"
      );
    }
  };

  const hexToUint8Array = (hex: string): Uint8Array => {
    const cleanHex = hex.startsWith("0x") ? hex.slice(2) : hex;
    const bytes = new Uint8Array(cleanHex.length / 2);
    for (let i = 0; i < cleanHex.length; i += 2) {
      bytes[i / 2] = parseInt(cleanHex.substr(i, 2), 16);
    }
    return bytes;
  };

  const handleSwapSolana = async (hexData: string, id: string) => {
    const connection = new Connection(SOLANA_RPC, "finalized");

    try {
      const serializedTx = hexToUint8Array(hexData);
      const transaction = VersionedTransaction.deserialize(serializedTx);

      const latestBlockhash = await connection.getLatestBlockhash("finalized");
      transaction.message.recentBlockhash = latestBlockhash.blockhash;

      if (walletProvider?.name === "Solflare") {
        const solflare = new Solflare();
        await solflare.connect();
        const signedTransaction = await solflare.signTransaction(transaction);

        const signature = await connection.sendRawTransaction(
          signedTransaction.serialize(),
          { skipPreflight: false, preflightCommitment: "finalized" }
        );

        console.log("✅ Transaction Signature:", signature);
        if (signature) {
          handleVerifyTx({
            transaction_id: id,
            hash: signature,
            chain_id: listChains?.find((item: any) => item.name === chainRouter)
              ?.chainId,
          });
        }
      } else {
        const provider = window?.phantom?.solana;
        if (!provider) {
          return;
        }
        await provider.connect();

        const signedTransaction = await provider.signTransaction(transaction);

        const signature = await connection.sendRawTransaction(
          signedTransaction.serialize(),
          { skipPreflight: false, preflightCommitment: "confirmed" }
        );

        console.log("signature", signature);

        if (signature) {
          handleVerifyTx({
            transaction_id: id,
            hash: signature,
            chain_id: listChains?.find((item: any) => item.name === chainRouter)
              ?.chainId,
          });
        }
      }
    } catch (error: any) {
      console.error("❌ Swap failed:", error);
      setIsVerified(false);
      setStepActive(1);
      setIsCreating(false);
      toast.error("Transaction failed: " + error.message);
    }
  };

  const handleSwapTon = async (data: any, id: any) => {
    if (!addressTon) {
      return;
    }
    if (!tonConnectUI.wallet) {
      toast.error("Tonkeeper is not connected");
      return;
    }
    try {
      setIsLoading(true);
      const currentTimeInSeconds = Math.floor(Date.now() / 1000);
      const validUntil = currentTimeInSeconds + 300;
      const response = await tonConnectUI?.sendTransaction({
        validUntil: validUntil,
        messages: data?.tonMessages.map((message: any) => ({
          address: message.address,
          amount: message.amount,
          payload: message.payload,
        })),
      });
      if (response.boc) {
        handleVerifyTx({
          transaction_id: id,
          hash: response.boc,
          chain_id: listChains?.find((item: any) => item.name === chainRouter)
            ?.chainId,
        });
      }
      setIsLoading(false);
    } catch (e: any) {
      console.log("err swap", e);
      if (e.toString().search("Transaction was not sent") !== -1) {
        toast.error("Transaction was not sent");
      } else if (
        e.toString().search("User rejects the action in the wallet") !== -1
      ) {
        toast.error("User rejects the action in the wallet");
      } else {
        toast.error("Somethings went wrong, please try again");
      }
      setIsLoading(false);
      setIsVerified(false);
      setStepActive(1);
      setIsCreating(false);
    }
  };

  const getAllowance = async () => {
    try {
      setIsLoading(true);
      const amountAllowance = await getTokenInfo(
        simulateState?.routeAdd,
        fromAsset?.address,
        address
      );
      setIsLoading(false);
      setAllowance(Number(amountAllowance.allowance));
    } catch (error) {
      setAllowance(0);
      console.error("error", error);
      setIsLoading(false);
    }
  };

  const approveBuy = async () => {
    try {
      if (isLoading) return;
      setIsLoading(true);
      const gasPrice = await Web3.eth.getGasPrice();
      const contract = new Web3.eth.Contract(abiToken, fromAsset?.address);
      await contract.methods
        .approve(simulateState?.routeAdd, ethers.MaxUint256.toString())
        .send({ from: address, gasPrice: gasPrice.toString() })
        .then(async () => {
          setIsLoading(false);
          await getAllowance();
        })
        .catch((err: any) => {
          console.error("Err approve", err);
          toast.error("User rejected");
          setIsLoading(false);
        });
    } catch (error: any) {
      console.error("Error approve", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (reCallFunc) {
      const intervalCalFunc = setInterval(() => {
        const token = localStorage.getItem("TOKEN");
        if (token) {
          clearInterval(intervalCalFunc);
          handleExcuteSwap();
          setReCallFunc(false);
        }
      }, 1500);
    }
  }, [reCallFunc]);

  useEffect(() => {
    if (address && openConfirmModal) {
      getAllowance();
    }
  }, [address, openConfirmModal]);

  // Reset all when close modal
  useEffect(() => {
    if (!openConfirmModal) {
      setTextModalTransaction("Confirm Swap");
      setFromAmount(0);
      setToAmount(0);
      setIsCreating(true);
      setIsSentTx(true);
      setIsVerified(true);
      setStepActive(0);
      setIsSwap(false);
    }
  }, [openConfirmModal]);

  return (
    <ConfirmSwapContainer>
      <>
        <ConfirmSwapHeader className={theme}>
          <div>
            <div>
              <p>You send</p>
              <div>
                <figure>
                  <img
                    onError={(e) => (e.currentTarget.src = default_token_image)}
                    src={fromAsset?.img}
                    width="48"
                    height="48"
                    alt={fromAsset?.display_name}
                  />
                </figure>
                <p>{`${fromAsset?.symbol}`}</p>
              </div>
            </div>
            <p>{`${fromAmount}`}</p>
          </div>
          <div>
            <div>
              <p>You receive</p>
              <div>
                <figure>
                  <img
                    onError={(e) => (e.currentTarget.src = default_token_image)}
                    src={toAsset?.img}
                    width="48"
                    height="48"
                    alt={toAsset?.display_name}
                  />
                </figure>
                <p>{`${toAsset?.symbol}`}</p>
              </div>
            </div>
            <p>{`${toAmount}`}</p>
          </div>
        </ConfirmSwapHeader>
        <SwapDetails
          showDetail={true}
          realPrice={realPrice}
          fromAsset={fromAsset}
          toAsset={toAsset}
          slippageTolerance={slippageTolerance}
          minReceived={minReceived}
          simulateState={simulateState}
        />
        {isSwap ? (
          <ConfirmSwapButtons>
            <BlockSteps>
              {STEPS.map((item: any, index: number) => {
                return (
                  <BlockRightRow
                    key={index}
                    className={index === STEPS.length - 1 ? "hidden-step" : ""}
                  >
                    <div
                      className={
                        (index === 0 && index < stepActive && !isCreating) ||
                        (index === 1 && index < stepActive && !isSentTx) ||
                        (index === 2 && index < stepActive && !isVerified)
                          ? "action-error"
                          : index < stepActive
                          ? "action-dot"
                          : "img-dot"
                      }
                    ></div>
                    <div
                      className={
                        (index === 0 &&
                          index < stepActive - 1 &&
                          !isCreating) ||
                        (index === 1 && index < stepActive - 1 && !isSentTx)
                          ? "action-line-error"
                          : index < stepActive - 1
                          ? "action-line"
                          : "line"
                      }
                    ></div>
                    <div>
                      <h2
                        style={{
                          color:
                            (index === 0 &&
                              index < stepActive &&
                              !isCreating) ||
                            (index === 1 && index < stepActive && !isSentTx) ||
                            (index === 2 && index < stepActive && !isVerified)
                              ? "#B32222"
                              : index < stepActive
                              ? "#48ab60"
                              : "",
                        }}
                      >
                        {item.title}
                      </h2>
                      <p>{item.description}</p>
                    </div>
                  </BlockRightRow>
                );
              })}
            </BlockSteps>
          </ConfirmSwapButtons>
        ) : (
          <ConfirmSwapButtons>
            <ButtonCommon
              onClick={() => {
                setOpenConfirmModal(false);
              }}
              background={theme === "light" ? "#EEEEF0" : "#32363f"}
              color={theme === "light" ? "#141518" : "#8e8e8f"}
            >
              <p>Cancel</p>
            </ButtonCommon>
            {Number(fromAmount) > Number(allowance) &&
            chainRouter !== "Solana" &&
            chainRouter !== "Toncoin" &&
            fromAsset?.address?.toLowerCase() !==
              "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE".toLowerCase() ? (
              <ButtonCommon onClick={approveBuy} disabled={isLoading}>
                {isLoading ? (
                  <Loading status={true} title="Waiting" />
                ) : (
                  "Approve"
                )}
              </ButtonCommon>
            ) : (
              <ButtonCommon onClick={handleExcuteSwap} disabled={isLoading}>
                {isLoading ? (
                  <Loading status={true} title="Waiting" />
                ) : (
                  "Confirm & Swap"
                )}
              </ButtonCommon>
            )}
          </ConfirmSwapButtons>
        )}
      </>
    </ConfirmSwapContainer>
  );
};

export default ConfirmSwap;
